import { useCallback, useState } from "react";
import { message } from "antd";
import type { AxiosRequestConfig } from "axios";
import { api, errorMessage } from "./api";

// The dominant data-fetching pattern for mutations and one-off loads (architecture.md §11).
// Reference/dropdown data uses TanStack Query instead (see queries.ts).
export function useApi() {
  const [loading, setLoading] = useState(false);

  const request = useCallback(async <T,>(config: AxiosRequestConfig, opts?: { silent?: boolean }): Promise<T> => {
    setLoading(true);
    try {
      const res = await api.request<T>(config);
      return res.data;
    } catch (err) {
      if (!opts?.silent) message.error(errorMessage(err));
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { request, loading };
}
